import * as React from "react"
import type { SVGProps } from "react"
const SvgCheckMini = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="m6.7 9.6 5.9-5.9a1 1 0 0 1 .7-.28q.43 0 .7.28a1 1 0 0 1 .28.7 1 1 0 0 1-.28.7l-6.6 6.6q-.3.3-.7.3a1 1 0 0 1-.7-.3L3.4 9.1a1 1 0 0 1-.27-.7q0-.42.27-.7a1 1 0 0 1 .7-.28q.43 0 .7.28z" />
  </svg>
)
export default SvgCheckMini
